module.exports = __webpack_public_path__ + "img/DP005C_002.37f5a849.png";